import { Layout } from '@douyinfe/semi-ui';
const { Footer } = Layout;
const FooterIndex = () => {
  return <Footer></Footer>;
};

export default FooterIndex;
